/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import PlayBookHeader from './PlayBookHeader';
import { Button } from '@material-ui/core';
import RootedInLoveSVG from './RootedInLove'

const GetStarted = ({ classes, onGetStarted }) => {
    return (
        <div className={`${classes.contentContainer}`}>
            {/* <div id="headerAndCopyContainer"> */}
            <PlayBookHeader classes={classes} page="GetStarted" />
            <div id="getStartedCopy">
                <p>Say goodbye to generic gifts and hello to personalized romance! Our Playbook Assistant suggests creative ideas and unique gestures that will leave your Valentine wondering how you pulled off such an unforgettable celebration.</p>
            </div>
            {/* </div> */}
            <div id='getStartedButton'>
                <Button
                    fullWidth
                    onClick={onGetStarted}
                    classes={{ root: classes.button }}
                >
                    <span style={{ fontFamily: 'Raleway', fontSize: '14px' }}>
                        Get started
                    </span>
                </Button>
            </div>
            <p id="aiDisclaimer">Our AI is brilliant, but not infallible. Embrace the magic of unpredictability, and remember mistakes can happen when humans play with robots! We're continuously learning and evolving, just like any great love story. ✨</p>
            {/* <div id="aiDisclaimer" style={{ marginTop: '40px !important' }}>
                <AIDisclaimer />
            </div> */}
            <div id="rootedInSvgIcon">
                <RootedInLoveSVG />
            </div>
        </div>
    );
}

export default GetStarted;
